import React, { useState, useEffect } from "react";
import FormDataContent from "../../components/FormDataContent";
import ArrayInputContent from "../../components/ArrayInputContent";
import { TextInput, SelectInput, BooleanInput, FormDataConsumer } from "react-admin";
import { Field, useFormState } from "react-final-form";
import Layer from "../../components/Layer";
import AceEditorInput from "../../components/AceEditorInput";
import AccordionComponent from "../../components/AccordionComponent";
import useCampaignsInstructions from "./useCampaignsInstructions"
import useCustomQueryOptions from "./useCustomQueryOptions";
import { useRecordContext } from 'react-admin';
import { defaultOperators } from "react-querybuilder";
import { makeStyles } from '@material-ui/core/styles';

export const defaultOp = defaultOperators.map((op) => {
  return { id: op.name, name: op.label };
});

export const defaultOpWithCustom = [...defaultOp,{id:"existOne",name:"exist one"},{id:"notExistOne",name:"not exist one"},{ id: "existOneBy", name: "exist one by" },
{ id: "notexistOneBy", name: "not exist one by" }];//add some custom operator who will format the cel in specific situation on QueryBuilder

export  const reIndexedDefaultOperators = defaultOpWithCustom.map(({ id, name }) => ({
  name: id,
  label: id
}));

const useStyles = makeStyles({
  linkVariableDiv: {
      display: 'flex',
      gap: '1rem',
  },
  linkVariableDivItem: {
    flex: '1 1 0',
    minWidth: 200,
  },
});

const InjectionForm = ({ field = "", disabled = false, ...props }) => {
  const { InjectCustomJSCSSInstructionsComponent, InjectCustomTemplatesInstructionsComponent, InjectRewritersLinksInstructionsComponent } = useCampaignsInstructions();
  const source = field ? `${field}.` : "";
  const classes = useStyles();
  const record = useRecordContext();


  const [siteConfigOverridedID, setSiteConfigOverridedID] = useState(
    record.site_config_overrided || ""
  );

  const campaignsQueryOptionsFetched = useCustomQueryOptions(
    siteConfigOverridedID
  );

  const [ matchingOperator, setMatchingOperator] = useState(reIndexedDefaultOperators || []);
  const handleLinkVarChange = (e) => {
    var campaignsByName = {};
    campaignsQueryOptionsFetched.forEach(
      (object) => {
        campaignsByName[object.name] = object;
      }
    );
    setMatchingOperator(campaignsByName[e.target?.value].operators);
  }

  return (
    <>
      <FormDataContent dataContentTitle={"Custom JS/CSS"}>
        <AccordionComponent classNameAccordion={classes.accordion} title="How to use Custom JS/CSS?">
          <InjectCustomJSCSSInstructionsComponent/>
        </AccordionComponent>
        <AceEditorInput
          name={`${source}custom_css`}
          source={`${source}custom_css`}
          placeholder={`.main{color:inherit}`}
          labl={"Custom CSS"}
          minLines={3}
          mode={"css"}
          disabled={disabled}
        />
        <AceEditorInput
          name={`${source}custom_js`}
          source={`${source}custom_js`}
          placeholder={`console.log('Put your JS Script without <script> tag')`}
          labl={"Custom JS"}
          minLines={3}
          mode={"javascript"}
          disabled={disabled}
        />
      </FormDataContent>
      <FormDataContent dataContentTitle={"Custom Template"}>
      <AccordionComponent classNameAccordion={classes.accordion} title="How to use Custom Templates Injection?">
          <InjectCustomTemplatesInstructionsComponent/>
        </AccordionComponent>
        <ArrayInputContent
          arrayInputSource={`${source}elements_custom_template`}
          label={`Select your Custom Template to inject`}
          // classes={{SimpleFormIterator:simpleFormClass}}
          isDisableAdd={disabled}
        >
          <TextInput
            source={`css_selector`}
            label={`Choose your css selector`}
            helperText="HTML Elements to Target with selector"
            // className={simpleFormInputClass}
            fullWidth
            disabled={disabled}
            required
          />
          <SelectInput
            source={`position`}
            label={`Selector's Position`}
            helperText={`Adjacent position or replace any selector (default replace)`}
            choices={[
              { id: "before", name: "Before your selector" },
              { id: "replace", name: "Replace your selector (default)" },
              { id: "after", name: "After your selector" },
              { id: "prepend", name: "First child of your selector" },
              { id: "append", name: "Last child of your selector" },
            ]}
            defaultValue={"replace"}
            fullWidth
            disabled={disabled}
            required
          />
          <Field
            name={"Custom Template"}
            source={`injected`}
            properties_suffix={`_custom_template_properties`}
            height="100%"
            width="100%"
            fillPlaceholderFields={true}
            component={Layer}
            disabled={disabled}
          />
        </ArrayInputContent>
      </FormDataContent>
      <FormDataContent dataContentTitle={"Links rewriter"}>
      <AccordionComponent classNameAccordion={classes.accordion} title="How to use Links Rewriters Injection?">
          <InjectRewritersLinksInstructionsComponent/>
        </AccordionComponent>
        <ArrayInputContent
          arrayInputSource={`${source}links_rewriter`}
          label={`List Links to rewrite`}
          // classes={{SimpleFormIterator:simpleFormClass}}
          isDisableAdd={disabled}
        >
          <FormDataConsumer>
          {({ scopedFormData, getSource }) => {
            const useJsVars = scopedFormData?.link_use_js_vars;
            return (
              <>
                <BooleanInput
                  source={getSource?.('link_use_js_vars')}
                  label="Use dynamic rewriter with JS vars"
                />
                {useJsVars && (
                  <div className={classes.linkVariableDiv}>
                    <SelectInput
                      choices={campaignsQueryOptionsFetched}
                      source={getSource?.('link_js_vars_variable_name')}
                      optionText={"label"}
                      optionValue={"name"}
                      label={"select JS var"}
                      className={classes.linkVariableDivItem}
                      defaultValue={campaignsQueryOptionsFetched[0]?.name}
                      onChange={handleLinkVarChange}
                    />
                    <SelectInput
                      source={getSource?.('link_js_vars_operator')}
                      optionText={"label"}
                      optionValue={"name"}
                      label={'operator'}
                      choices={matchingOperator}
                      className={classes.linkVariableDivItem}
                    />
                    <TextInput
                      source={getSource?.('link_js_vars_value')}
                      label={"value"}
                      disabled={disabled}
                      className={classes.linkVariableDivItem}
                    />
                  </div>
                )}
                <BooleanInput
                  source={getSource?.('link_persist_query')}
                  onChange=''
                  label={"Persist query strings from source"}
                />
                <TextInput
                  source={getSource?.('link_replace_source')}
                  label={`Link Replace Source`}
                  helperText="Absolute Link Url to replace"
                  // className={simpleFormInputClass}
                  fullWidth
                  disabled={disabled}
                />
                <TextInput
                  source={getSource?.('link_replace_destination')}
                  label={`Link Replace Destination`}
                  helperText="New Absolute Link Url expected"
                  // className={simpleFormInputClass}
                  fullWidth
                  disabled={disabled}
                />
                <TextInput
                  source={getSource?.('link_replace_label')}
                  label={`Link Replace Label`}
                  helperText="New label link expected"
                  // className={simpleFormInputClass}
                  fullWidth
                  disabled={disabled}
                />
              </>
            );
            }}
          </FormDataConsumer>
        </ArrayInputContent>
      </FormDataContent>
    </>
  );
};

export default InjectionForm;
